import React from "react";
import GradientText from "@/components/GradiantTitle";

const DashboardHeader = () => {
  return (
    <div className="flex flex-col">
      <p className="text-primary-800 text-3xl font-normal mb-4">
        <GradientText>Reconciliation Dashboard</GradientText>
      </p>
    </div>
  );
};

export default DashboardHeader;
